<div>
  <mat-card appearance="outlined" class="z-depth">
    <mat-card-title i18n>
      You have been logged out
    </mat-card-title>

    <mat-divider></mat-divider>

    <mat-card-content>
      <p i18n>You may want to close the browser window or login again</p>
      <p>
        <a mat-flat-button color="primary" [routerLink]="['/']" i18n>Log in again</a>
      </p>
    </mat-card-content>
  </mat-card>
</div>
